var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mx-auto", attrs: { "data-user-profile-edit": "" } },
    [
      _c("omegaup-user-profile-wrapper", {
        attrs: {
          profile: _vm.profile,
          data: _vm.data,
          "selected-tab": _vm.currentSelectedTab,
          "has-password": _vm.hasPassword
        },
        on: {
          "update:selectedTab": function($event) {
            _vm.currentSelectedTab = $event
          },
          "update:selected-tab": function($event) {
            _vm.currentSelectedTab = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "message",
            fn: function() {
              return [
                !_vm.profile.is_own_profile && _vm.profile.is_private
                  ? _c("h1", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.ui.info(_vm.T.userProfileIsPrivate)) +
                          " "
                      )
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "title",
            fn: function() {
              return [
                _c("h3", { staticClass: "text-center mt-1" }, [
                  _vm._v(_vm._s(_vm.currentTitle))
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _vm.currentSelectedTab === "view-profile"
                  ? [
                      _c("omegaup-user-view-profile", {
                        attrs: {
                          data: _vm.data,
                          profile: _vm.profile,
                          "profile-badges": _vm.profileBadges,
                          "visitor-badges": _vm.visitorBadges,
                          "selected-tab": _vm.currentViewProfileSelectedTab,
                          "heatmap-data": _vm.heatmapData,
                          "available-years": _vm.availableYears
                        },
                        on: {
                          "update:selectedTab": function($event) {
                            _vm.currentViewProfileSelectedTab = $event
                          },
                          "update:selected-tab": function($event) {
                            _vm.currentViewProfileSelectedTab = $event
                          },
                          "heatmap-year-changed": function(year) {
                            return _vm.$emit("heatmap-year-changed", year)
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "edit-basic-information"
                  ? [
                      _c("omegaup-user-edit-basic-information", {
                        attrs: {
                          data: _vm.data,
                          profile: _vm.profile,
                          countries: _vm.countries
                        },
                        on: {
                          "update-user-basic-information": function(request) {
                            return _vm.$emit(
                              "update-user-basic-information",
                              request
                            )
                          },
                          "update-user-basic-information-error": function(
                            request
                          ) {
                            return _vm.$emit(
                              "update-user-basic-information-error",
                              request
                            )
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "edit-preferences"
                  ? [
                      _c("omegaup-user-edit-preferences", {
                        attrs: { profile: _vm.profile },
                        on: {
                          "update-user-preferences": function(request) {
                            return _vm.$emit("update-user-preferences", request)
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "manage-schools"
                  ? [
                      _c("omegaup-user-manage-schools", {
                        attrs: {
                          profile: _vm.profile,
                          "search-result-schools": _vm.searchResultSchools
                        },
                        on: {
                          "update-search-result-schools": function(query) {
                            return _vm.$emit(
                              "update-search-result-schools",
                              query
                            )
                          },
                          "update-user-schools": function(request) {
                            return _vm.$emit("update-user-schools", request)
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "manage-identities"
                  ? [
                      _c("omegaup-user-manage-identities", {
                        attrs: { identities: _vm.identities },
                        on: {
                          "add-identity": function(request) {
                            return _vm.$emit("add-identity", request)
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "manage-api-tokens"
                  ? [
                      _c("omegaup-user-manage-api-tokens", {
                        attrs: { "api-tokens": _vm.apiTokens },
                        on: {
                          "create-api-token": function(request) {
                            return _vm.$emit("create-api-token", request)
                          },
                          "revoke-api-token": function(request) {
                            return _vm.$emit("revoke-api-token", request)
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "change-password"
                  ? [
                      _c("omegaup-user-edit-password", {
                        on: {
                          "update-password": function(request) {
                            return _vm.$emit("update-password", request)
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "add-password"
                  ? [
                      _c("omegaup-user-add-password", {
                        attrs: { username: _vm.profile.username },
                        on: {
                          "add-password": function(request) {
                            return _vm.$emit("add-password", request)
                          }
                        }
                      })
                    ]
                  : _vm.currentSelectedTab === "delete-account"
                  ? [
                      _c("omegaup-user-delete-account", {
                        attrs: { username: _vm.profile.username },
                        on: {
                          "request-delete-account": function($event) {
                            return _vm.$emit("request-delete-account")
                          }
                        }
                      })
                    ]
                  : _c("div", [
                      _vm._v(" " + _vm._s(_vm.currentSelectedTab) + " ")
                    ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }